import React from 'react';
import { getIn } from 'formik';

import fieldStyles from 'buyside/components/presentation/Form/Field/fieldStyles.scss';

const dollarSignInputField = ({ field, form: { touched, errors, isSubmitting }, ...props }) => {
  const { label, addon, note, customStyles } = props;
  const value = field.value || field.value === 0 ? field.value : '';
  const isTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  const styles = customStyles ? customStyles : fieldStyles;

  return (
    <div className={styles.fieldContainer}>
      <label className={styles.fieldContainerLabel}>
        <div className={styles.fieldLabel}>{label}</div>
        <div className={`input-group ${styles.inputFieldGroup}`}>
          {addon && <span className="input-group-addon">{addon}</span>}
          <input
            {...field}
            min="0"
            className={`form-control ${styles.input} ${addon && styles.withAddon}`}
            value={value}
            disabled={isSubmitting}
          />
        </div>
      </label>
      {isTouched && error && <div className={styles.fieldError}>{error}</div>}
      {note && <div className={styles.fieldNote}>{note}</div>}
    </div>
  );
};

export default dollarSignInputField;
